import localhost from "../../../apis/localhost";
import { isSiteBlocked } from "../../../constants/sharepointAccess";
import { selectSharepointRestricted } from "../selectors";
import {
  setSharepointData,
  setSharepointError,
  setSharepointLoading,
} from "../sharepointSlice";
import { CONNECTIVITY_ERROR, NO_SITE_ERROR, SKIP_REDIRECT } from "./constants";
import { handledPolicyError } from "./policyErrors";
import { unpinSharepointSite } from "./unpinSharepointSite";
import { beginRequest, isCurrentRequest, statusOf } from "./utils";

export const fetchSharepointCollections =
  (site) => async (dispatch, getState) => {
    if (isSiteBlocked(site, selectSharepointRestricted(getState()))) {
      dispatch(setSharepointData([]));
      return;
    }
    const requestId = beginRequest(dispatch, getState);
    const params = {
      siteHost: site.host,
      sitePath: site.sitePath,
    };

    try {
      dispatch(setSharepointLoading(true));
      dispatch(setSharepointError(null));

      const response = await localhost.get("/sharepoint/collections", {
        params,
        ...SKIP_REDIRECT,
      });

      if (!isCurrentRequest(getState, requestId)) {
        return;
      }

      // Extract collections from the response, which may be either directly in the response data
      // (for backward compatibility) or in a collections property of the response data (for the new format)
      const collections = response.data.collections || response.data;

      dispatch(setSharepointData(collections));
    } catch (error) {
      if (!isCurrentRequest(getState, requestId)) {
        return;
      }
      if (handledPolicyError(dispatch, error)) {
        dispatch(setSharepointData([]));
        return;
      }
      const status = statusOf(error);

      if (status === 403 || status === 404) {
        dispatch(setSharepointError(new Error(NO_SITE_ERROR)));

        if (site.isPinned && !selectSharepointRestricted(getState())) {
          dispatch(unpinSharepointSite(site.id));
        }
      } else if (status >= 500 && status < 600) {
        dispatch(setSharepointError(new Error(CONNECTIVITY_ERROR)));
      }

      dispatch(setSharepointData([]));
    } finally {
      if (isCurrentRequest(getState, requestId)) {
        dispatch(setSharepointLoading(false));
      }
    }
  };
